import moment from "moment";
// Show-hide table filters
$("#filters-toogle").click(function () {
    $(".top-filters-wrapper").addClass("is-open");
    $("body").addClass("filters-open");
});
$(".table-filters-close").click(function () {
    $(".top-filters-wrapper").removeClass("is-open");
    $("body").removeClass("filters-open");
});

window.addSelectedFilter = function (
    data                  = "",
    callback              = function () {
    },
    selectorId            = '',
    shouldScrollToElement = false
) {
    Object.entries(data).forEach(([filter, value]) => {
        deleteCurrentParam(filter, null);

        setCurrentParam(filter, value, false);

    });
    loadPage(1, callback, selectorId, shouldScrollToElement);
};

window.loadSelectedFiltersFromCurrentUrl = function (callback = fillSelectedFilter) {
    let searchParams = new URLSearchParams(window.location.search);
    if (!$.isEmptyObject(searchParams) && searchParams.length !== 0) {
        searchParams.forEach((value, filter) => {
            if (filter !== 'count' && filter !== 'resultsPerPage' && filter !== 'currentPage') {
                callback(filter, value);
            }
        });
    }
};

function fillSelectedFilter(
    filter = "",
    value  = "",
) {
    if (filter && 0 !== filter.length && value && 0 !== value.length) {
        switch (filter) {
            case "orderBy":
                deleteCurrentParam(filter, null);
                break;
            case "orderDir":
                deleteCurrentParam(filter, null);
                break;
            case "fecha_desde":
                $("#selectDateRange").val(moment(value, 'YYYY-MM-DD').format(idiomaFormatoFecha));
                break;
            case "fecha_hasta":
                let inputFecha = $("#selectDateRange").val();
                $("#selectDateRange").val(inputFecha + ' - ' + moment(value, 'YYYY-MM-DD').format(idiomaFormatoFecha));
                break;
            case "total":
                $("#inputTotal").val(value);
                break;
            case "codigo":
                $("#inputCodigo").val(value);
                break;
            case "tipo":
                $("#selectTipo").val(value);
                break;
            case "estado":
                $("#selectEstado").val(value);
                break;
            case "id_tipo_articulo":
                $(".selectTipoArticulo").val(value);
                break;
            case "ean":
                $(".inputEan").val(value);
                break;
            case "id_pedido":
                $("#inputIdPedido").val(value);
                break;
        }
    }
}

window.cleanSelectedFilters = function () {
    let searchParams = new URLSearchParams(window.location.search);
    if (!$.isEmptyObject(searchParams) && searchParams.length !== 0) {
        const searchParamsAux = Array.from(searchParams);
        for (const element of searchParamsAux) {
            const [filter, value] = element;
            if (filter !== 'pagina' && filter !== 'orderBy' && filter !== 'orderDir') {
                deleteCurrentParam(filter, null);
            }
        }
    }
};
